import http from "./http";

export async function login(username, password) {
    await http.post("/login", { username, password });
}

export async function me() {
    const res = await http.get("/api/me");
    return res.data;
}

export async function logout() {
    await http.post("/logout");
}
